export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8734.ef17e8a8.jpg";